/* damax-producto.js — el código de las páginas de producto de Damax (assets/ del tema).
 *
 * Uno solo para todas las páginas: el navegador lo guarda y no lo vuelve a bajar de producto en
 * producto. Lo carga la página con defer. Escrito para los celulares más sencillos (dueño,
 * 2026-10-19: "la página debe funcionar con total fluidez hasta en los dispositivos más gama baja"):
 *  - En celular no hay lienzo de partículas (el fondo es una textura fija en CSS) y no se reserva
 *    memoria para él. Antes se creaba del alto de toda la página (unos 14 MB) y se volvía a crear
 *    cada vez que la barra del navegador aparecía o se escondía al hacer scroll.
 *  - En computador el lienzo mide lo que la ventana y sigue el scroll: el mismo efecto, sin
 *    redibujar 35 MB sesenta veces por segundo.
 *  - Los videos se bajan y se reproducen solo cuando están cerca de la pantalla, y se pausan al
 *    salir. En celular, la versión de 480p.
 *  - Nada escucha el dedo en toda la página: el slider se arrastra solo desde su bolita.
 * Ojo: en computador (desde 990 px) el tema Fabric no hace scroll en la ventana sino dentro de
 * .page-wrapper, así que window.scrollY vale 0. Todo se mide contra la posición del hero en pantalla
 * y para bajar a una sección se usa scrollIntoView, que sirve con cualquiera de los dos.
 * Copia de trabajo: salidas/damax-producto.js
 */
(function () {
  'use strict';
  var hero = document.querySelector('.ciclogram-hero');
  if (!hero) return;
  var movil = window.matchMedia('(max-width:768px)').matches;
  var raiz = getComputedStyle(document.documentElement);
  var css = function (v) { return raiz.getPropertyValue(v).trim(); };
  var luego = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };

  // ------------------------------------------------------------ partículas (solo computador)
  function particulas() {
    var canvas = hero.querySelector('.particle-canvas');
    if (!canvas) return;
    if (movil) { canvas.remove(); return; }
    var ctx = canvas.getContext('2d');
    var colores = [css('--mauve'), css('--mauve-oscuro') || css('--dark')];
    var W = 0, H = 0, VH = 0, corrido = -1, ps = [], i;
    function medir() {
      W = hero.offsetWidth; H = hero.offsetHeight; VH = window.innerHeight;
      canvas.width = W; canvas.height = VH; canvas.style.height = VH + 'px'; corrido = -1;
    }
    medir();
    for (i = 0; i < 300; i++) {
      ps.push({x: Math.random() * W, y: Math.random() * H, z: Math.random() * 3 + 1,
               r: Math.random() * 2 + 1, c: colores[i % 2], a: Math.random() * Math.PI * 2,
               v: Math.random() * .2 + .1, vx: 0, vy: 0});
    }
    var espera;
    window.addEventListener('resize', function () { clearTimeout(espera); espera = setTimeout(medir, 150); });
    if (window.ResizeObserver) new ResizeObserver(function () { H = hero.offsetHeight; }).observe(hero);
    var tX = 0, tY = 0, cX = 0, cY = 0, mX = -1e3, mY = -1e3;
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      mX = e.clientX - r.left; mY = e.clientY - r.top;
      tX = Math.max(-.5, Math.min(.5, (mX / r.width) * 2 - 1));
      tY = Math.max(-.5, Math.min(.5, (mY / r.height) * 2 - 1));
    }, {passive: true});
    hero.addEventListener('mouseleave', function () { tX = tY = 0; mX = mY = -1e3; });
    function cuadro() {
      var o = Math.max(0, Math.min(-hero.getBoundingClientRect().top, H - VH));
      if (o !== corrido) { corrido = o; canvas.style.transform = 'translate3d(0,' + o + 'px,0)'; }
      ctx.clearRect(0, 0, W, VH);
      cX += (tX - cX) * .08; cY += (tY - cY) * .08;
      var t = Date.now() * .001;
      for (var k = 0; k < ps.length; k++) {
        var p = ps[k];
        p.x += Math.sin(t * p.v + p.a) * .3 / p.z;
        p.y += Math.cos(t * p.v + p.a) * .3 / p.z;
        var dx = p.x - mX, dy = p.y - mY, d = Math.sqrt(dx * dx + dy * dy);
        if (d < 200 && d > 0) { var f = (200 - d) / 200; p.vx += dx / d * f * 5; p.vy += dy / d * f * 5; }
        p.x += p.vx; p.y += p.vy; p.vx *= .85; p.vy *= .85;
        if (p.x < -50) p.x = W + 50; else if (p.x > W + 50) p.x = -50;
        if (p.y < -50) p.y = H + 50; else if (p.y > H + 50) p.y = -50;
        var y = p.y - cY * 15 / p.z - o;
        if (y < -8 || y > VH + 8) continue;   // fuera de la ventana: no se dibuja
        ctx.beginPath();
        ctx.arc(p.x - cX * 15 / p.z, y, p.r, 0, 6.2832);
        ctx.fillStyle = p.c;
        ctx.globalAlpha = Math.max(.2, 1 - p.z / 4);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      requestAnimationFrame(cuadro);
    }
    requestAnimationFrame(cuadro);
  }

  // ------------------------------------------------------------ el hero en 3D (solo computador)
  function capas3d() {
    if (movil) return;
    var pc = document.getElementById('parallax-container');
    if (!pc) return;
    var capas = pc.querySelectorAll('.parallax-layer'), boton = hero.querySelector('.rsi-btn-wrapper');
    var pendiente = false, ex = 0, ey = 0;
    var factor = function (l) {
      return l.classList.contains('parallax-layer-1') ? .06 : l.classList.contains('parallax-layer-2') ? -.10 : -.18;
    };
    var quieto = function () { capas.forEach(function (l) { l.style.transform = 'translate(-50%,-50%)'; }); };
    hero.addEventListener('mousemove', function (e) {
      if (hero.getBoundingClientRect().top < -window.innerHeight) return;   // ya no se ve el hero
      ex = e.clientX; ey = e.clientY;
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        if (boton && ey > boton.getBoundingClientRect().bottom) { quieto(); return; }
        var r = pc.getBoundingClientRect(), x = ex - r.left - r.width / 2, y = ey - r.top - r.height / 2;
        capas.forEach(function (l) {
          var s = factor(l);
          l.style.transform = 'translate(calc(-50% + ' + (x * s * .35) + 'px),calc(-50% + ' + (y * s * .45) + 'px))';
        });
      });
    }, {passive: true});
    hero.addEventListener('mouseleave', quieto);
  }

  // ------------------------------------------------------------ slider antes/después: solo la bolita
  function sliders() {
    hero.querySelectorAll('.before-after-wrapper').forEach(function (w) {
      var antes = w.querySelector('.before-layer'), linea = w.querySelector('.slider-line'),
          bolita = w.querySelector('.slider-button');
      if (!antes || !linea || !bolita) return;
      var arrastrando = false, pendiente = false, ultimo = 0;
      var poner = function (x) {
        var r = w.getBoundingClientRect(), p = Math.max(0, Math.min(100, (x - r.left) / r.width * 100));
        antes.style.clipPath = 'polygon(0 0,' + p + '% 0,' + p + '% 100%,0 100%)';
        linea.style.left = p + '%';
      };
      var soltar = function () { arrastrando = false; linea.classList.remove('is-active'); };
      bolita.addEventListener('pointerdown', function (e) {
        arrastrando = true;
        try { bolita.setPointerCapture(e.pointerId); } catch (_) {}
        linea.classList.add('is-active'); poner(e.clientX); e.preventDefault();
      });
      bolita.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        ultimo = e.clientX;
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () { pendiente = false; poner(ultimo); });
      });
      bolita.addEventListener('pointerup', soltar);
      bolita.addEventListener('pointercancel', soltar);
      bolita.addEventListener('lostpointercapture', soltar);
    });
  }

  // ------------------------------------------------------------ acordeones
  function acordeones() {
    hero.querySelectorAll('.accordion-item').forEach(function (item) {
      var cab = item.querySelector('.accordion-header'), cuerpo = item.querySelector('.accordion-body');
      if (!cab || !cuerpo) return;
      cab.addEventListener('click', function () {
        if (item.classList.contains('active')) {
          cuerpo.style.height = cuerpo.scrollHeight + 'px'; cuerpo.style.opacity = '1';
          requestAnimationFrame(function () { requestAnimationFrame(function () {
            cuerpo.style.height = '0'; cuerpo.style.opacity = '0'; cuerpo.style.marginTop = '0';
          }); });
          item.classList.remove('active');
        } else {
          item.classList.add('active');
          cuerpo.style.height = cuerpo.scrollHeight + 'px'; cuerpo.style.opacity = '1'; cuerpo.style.marginTop = '.5rem';
          cuerpo.addEventListener('transitionend', function () {
            if (item.classList.contains('active')) cuerpo.style.height = 'auto';
          }, {once: true});
        }
      });
    });
  }

  // ------------------------------------------------------------ contador hasta la medianoche
  // Llega a cero a medianoche todos los días y no se reinicia al recargar. Solo cambia el texto
  // de los tres números: nada de volver a armar el reloj cada segundo.
  function contador() {
    var reloj = document.getElementById('reloj-entrega');
    if (!reloj) return;
    reloj.innerHTML = '<span class="rb"><b>00</b><i>HOR</i></span><span class="rs">:</span>' +
                      '<span class="rb"><b>00</b><i>MIN</i></span><span class="rs">:</span>' +
                      '<span class="rb"><b>00</b><i>SEG</i></span>';
    var n = reloj.querySelectorAll('b'), dos = function (x) { return (x < 10 ? '0' : '') + x; };
    var tic = function () {
      var ahora = new Date(), fin = new Date(ahora); fin.setHours(24, 0, 0, 0);
      var s = Math.max(0, Math.floor((fin - ahora) / 1000));
      n[0].textContent = dos(Math.floor(s / 3600)); n[1].textContent = dos(Math.floor(s % 3600 / 60)); n[2].textContent = dos(s % 60);
    };
    tic(); setInterval(tic, 1000);
  }

  // ------------------------------------------------------------ videos del tutorial
  function videos() {
    var vs = hero.querySelectorAll('video.tutorial-gif');
    if (!vs.length) return;
    var cargar = function (v) {
      if (!v.getAttribute('src')) { var s = (movil && v.dataset.srcMovil) || v.dataset.src; if (s) v.src = s; }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    };
    vs.forEach(function (v) { v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true; });
    if (!('IntersectionObserver' in window)) { vs.forEach(cargar); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) cargar(en.target); else en.target.pause(); });
    }, {rootMargin: '300px 0px'});
    vs.forEach(function (v) { io.observe(v); });
  }

  // ------------------------------------------------------------ bajar a una sección (flecha, reseñas)
  function ir(destino) {
    var cab = document.getElementById('header-component');
    destino.style.scrollMarginTop = ((cab ? cab.getBoundingClientRect().height : 0) + 8) + 'px';
    destino.scrollIntoView({behavior: 'smooth', block: 'start'});
  }
  function enlaces() {
    var flecha = hero.querySelector('.scroll-arrow-float'), tutorial = document.getElementById('tutorial-anchor');
    if (flecha && tutorial) flecha.addEventListener('click', function (e) { e.preventDefault(); ir(tutorial); });
    var pill = document.querySelector('.calificacion-pill'), resenas = document.getElementById('resenas');
    if (pill && resenas) pill.addEventListener('click', function (e) { e.preventDefault(); ir(resenas); });
  }

  // ------------------------------------------------------------ así recibes tu pedido
  // Días hábiles (sin sábados ni domingos). Los días salen de la página (data-min, data-max:
  // secciones_pagina.DIAS_MIN / DIAS_MAX), no de aquí.
  function entrega() {
    var caja = document.querySelector('.entrega-pasos');
    if (!caja) return;
    var MIN = +caja.dataset.min || 2, MAX = +caja.dataset.max || 6;
    var MES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    var f = function (d) { return d.getDate() + ' ' + MES[d.getMonth()]; };
    var habil = function (d) { return d.getDay() !== 0 && d.getDay() !== 6; };
    var mas = function (d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); if (habil(r)) n--; } return r; };
    var hoy = new Date(); hoy.setHours(0, 0, 0, 0);
    var sale = habil(hoy) ? hoy : mas(hoy, 1);
    var pon = function (k, t) { caja.querySelectorAll('[data-ep="' + k + '"]').forEach(function (e) { e.textContent = t; }); };
    pon('hoy', 'Hoy, ' + f(hoy));
    pon('despacho', f(sale) + ' – ' + f(mas(sale, 1)));
    pon('llega', f(mas(hoy, MIN)) + ' – ' + f(mas(hoy, MAX)));
  }

  // ------------------------------------------------------------ la calificación: del ancho de los precios en celular
  function calificacion() {
    var pill = document.querySelector('.calificacion-pill'), precios = document.querySelector('.mobile-prices');
    if (!pill) return;
    var ancho = 0;
    var medir = function () {
      if (window.innerWidth === ancho) return;   // la barra del navegador también dispara "resize"
      ancho = window.innerWidth;
      if (!precios || !precios.offsetWidth) { pill.style.width = ''; return; }
      var r = [].filter.call(precios.querySelectorAll('.price-old,.price-new,.price-save'), function (e) { return e.offsetWidth; })
                .map(function (e) { return e.getBoundingClientRect(); });
      if (r.length) pill.style.width = Math.round(Math.max.apply(null, r.map(function (x) { return x.right; })) -
                                                  Math.min.apply(null, r.map(function (x) { return x.left; }))) + 'px';
    };
    medir();
    window.addEventListener('resize', medir);
    if (document.fonts) document.fonts.ready.then(function () { ancho = 0; medir(); });
  }

  // ------------------------------------------------------------ preguntas frecuentes: las pestañas
  function pestanas() {
    document.querySelectorAll('.faq-tab').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.dataset.faq, caja = b.closest('.hero-layer-preguntas');
        caja.querySelectorAll('.faq-tab').forEach(function (x) { x.classList.toggle('activo', x === b); });
        caja.querySelectorAll('.faq-panel').forEach(function (p) { p.classList.toggle('activo', p.dataset.faq === k); });
      });
    });
  }

  // ------------------------------------------------------------ galería: el zoom solo sobre la foto (computador)
  // Para saber si el mouse está sobre la foto o sobre lo transparente, una copia de 160 px que se
  // hace al primer paso del mouse (antes eran 10 copias de 1080 px apenas cargaba la página).
  function galeria() {
    if (movil) return;
    hero.querySelectorAll('.collage-item-wrapper').forEach(function (w) {
      var img = w.querySelector('.collage-item-img');
      if (!img) return;
      var lado = 160, ctx = null, listo = false;
      var crear = function () {
        if (ctx || !img.complete || !img.naturalWidth) return;
        var c = document.createElement('canvas'); c.width = c.height = lado;
        ctx = c.getContext('2d', {willReadFrequently: true});
        try { ctx.drawImage(img, 0, 0, lado, lado); ctx.getImageData(0, 0, 1, 1); listo = true; } catch (e) { listo = false; }
      };
      w.addEventListener('mouseenter', crear);
      w.addEventListener('mousemove', function (e) {
        if (!listo) { w.classList.add('img-hovered'); return; }
        var r = img.getBoundingClientRect();
        var px = Math.floor((e.clientX - r.left) / r.width * lado), py = Math.floor((e.clientY - r.top) / r.height * lado);
        if (px < 0 || py < 0 || px >= lado || py >= lado) { w.classList.remove('img-hovered'); return; }
        w.classList.toggle('img-hovered', ctx.getImageData(px, py, 1, 1).data[3] > 10);
      });
      w.addEventListener('mouseleave', function () { w.classList.remove('img-hovered'); });
    });
  }

  // El hero de celular como carrusel (secciones_pagina.carrusel_hero_movil). El dedo lo mueve el navegador
  // con su scroll nativo y su imán: aquí solo van las flechas, los puntos y bajar la imagen siguiente.
  // Cuál se ve lo dice un IntersectionObserver, sin escuchar el scroll.
  function heroCarrusel() {
    var c = document.querySelector('.hero-carrusel');
    if (!c || !window.matchMedia('(max-width:768px)').matches) return;
    var pista = c.querySelector('.hc-pista'), reales = pista.querySelectorAll('.hc-foto');
    var puntos = c.querySelectorAll('.hc-punto'), ant = c.querySelector('.hc-ant'), sig = c.querySelector('.hc-sig');
    var n = reales.length;
    if (n < 2) return;
    // Da la vuelta con las flechas y con el dedo (dueño, 2026-10-27 y 28): antes de la primera va una copia de
    // la última y después de la última una copia de la primera. Al quedar quieta en una copia, salta sin
    // animación a la foto de verdad, y no se nota porque son iguales.
    var alFinal = reales[0].cloneNode(true), alInicio = reales[n - 1].cloneNode(true);
    [alFinal, alInicio].forEach(function (f) {
      f.setAttribute('aria-hidden', 'true');
      var img = f.querySelector('img');
      if (img) { img.loading = 'lazy'; img.removeAttribute('fetchpriority'); }
    });
    // La copia de la última no se baja hasta que la clienta mueva el carrusel: así no compite con la primera.
    var imgInicio = alInicio.querySelector('img'), fuentes = null;
    if (imgInicio) {
      fuentes = {src: imgInicio.getAttribute('src'), srcset: imgInicio.getAttribute('srcset')};
      imgInicio.removeAttribute('srcset'); imgInicio.removeAttribute('src');
    }
    pista.appendChild(alFinal);
    pista.insertBefore(alInicio, reales[0]);
    var fotos = pista.querySelectorAll('.hc-foto');
    var pos = 1, tocando = false, quieto = null, movida = false;
    function saltar(p) {
      pos = p;
      pista.style.scrollBehavior = 'auto';
      pista.scrollLeft = p * pista.clientWidth;
      pista.style.scrollBehavior = '';
    }
    function despertar() {
      if (movida) return;
      movida = true;
      if (fuentes) { imgInicio.setAttribute('srcset', fuentes.srcset); imgInicio.setAttribute('src', fuentes.src); }
    }
    // Si la pista quedó en una copia, primero pasa a la foto de verdad: desde una copia la flecha no tendría
    // hacia dónde ir y el carrusel quedaba quieto (dueño, 2026-10-28).
    function acomodar() {
      var p = Math.round(pista.scrollLeft / pista.clientWidth);
      if (p === 0) saltar(n);
      else if (p === n + 1) saltar(1);
      else pos = p;
    }
    // Nunca pasa por encima de las demás: a la de al lado se desliza, y si está más lejos (un punto) salta.
    function ir(p) {
      despertar();
      if (Math.abs(p - pos) > 1) { saltar(p); return; }
      pista.scrollTo({left: p * pista.clientWidth, behavior: 'smooth'});
    }
    function quieta() {
      clearTimeout(quieto);
      quieto = setTimeout(function () { if (!tocando) acomodar(); }, 120);
    }
    function marcar(p) {
      pos = p;
      var i = (p - 1 + n) % n;
      if (i > 0) c.classList.add('tocado');
      for (var k = 0; k < puntos.length; k++) puntos[k].classList.toggle('activo', k === i);
      var siguiente = reales[i + 1] && reales[i + 1].querySelector('img');
      if (siguiente) siguiente.loading = 'eager';
    }
    saltar(1);
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) marcar(Array.prototype.indexOf.call(fotos, e.target));
        });
      }, {root: pista, threshold: 0.6});
      for (var i = 0; i < fotos.length; i++) obs.observe(fotos[i]);
    }
    pista.addEventListener('touchstart', function () { tocando = true; despertar(); }, {passive: true});
    // touchcancel también suelta: el navegador lo manda a veces en lugar de touchend, y sin esto el carrusel
    // creía que el dedo seguía encima y nunca salía de la copia.
    function soltar() { tocando = false; quieta(); }
    pista.addEventListener('touchend', soltar, {passive: true});
    pista.addEventListener('touchcancel', soltar, {passive: true});
    pista.addEventListener('scroll', quieta, {passive: true});
    pista.addEventListener('scrollend', function () { if (!tocando) acomodar(); });
    // Solo cuando cambia el ancho (girar el celular): en el celular el alto cambia al aparecer o esconderse la
    // barra del navegador, y acomodar ahí interrumpía el dedo.
    var ancho = pista.clientWidth;
    window.addEventListener('resize', function () {
      if (pista.clientWidth !== ancho) { ancho = pista.clientWidth; saltar(pos); }
    });
    ant.addEventListener('click', function () { c.classList.add('tocado'); acomodar(); ir(pos - 1); });
    sig.addEventListener('click', function () { c.classList.add('tocado'); acomodar(); ir(pos + 1); });
    Array.prototype.forEach.call(puntos, function (b, k) {
      b.addEventListener('click', function () { acomodar(); ir(k + 1); });
    });
    var segunda = reales[1].querySelector('img');
    if (segunda) luego(function () { segunda.loading = 'eager'; }, {timeout: 3000});
  }

  // Sobre una imagen o un video de la página no sale el menú del clic derecho (guardar, copiar) ni se pueden
  // arrastrar (dueño, 2026-10-27). Solo ahí: el texto se sigue pudiendo seleccionar y copiar.
  function protegerImagenes() {
    function esMedio(e) { return e.target && e.target.closest && e.target.closest('img,video,picture,canvas'); }
    hero.addEventListener('contextmenu', function (e) { if (esMedio(e)) e.preventDefault(); });
    hero.addEventListener('dragstart', function (e) { if (esMedio(e)) e.preventDefault(); });
  }

  // Lo que se toca o se ve de una vez, ya; lo demás, cuando el navegador esté libre.
  protegerImagenes(); heroCarrusel(); sliders(); acordeones(); contador(); videos(); enlaces(); entrega(); calificacion(); pestanas();
  luego(function () { particulas(); capas3d(); galeria(); }, {timeout: 2000});
})();
